import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import theme from '../theme';

const statusLabels = {
  held: { emoji: '🔒', label: 'Bloccato (in corso)', bg: 'warningBgSoft', color: 'warningText' },
  transferred: { emoji: '✅', label: 'Trasferito', bg: 'primaryLight', color: 'primary' },
};

function Spese({ session }) {
  const [spese, setSpese] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchSpese(); }, []);

  const fetchSpese = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from('stripe_payments')
      .select('*, applications(id, jobs(title, category))')
      .eq('client_user_id', session?.user?.id)
      .order('created_at', { ascending: false });
    if (error) {
      console.error('Errore caricamento spese:', error);
    }
    if (data) setSpese(data);
    setLoading(false);
  };

  return (
    <div>
      <h3 style={{ margin: '0 0 12px', color: theme.colors.textPrimary, fontSize: theme.font.size.lg }}>Lavori commissionati</h3>

      {loading && <p style={{ color: theme.colors.textMuted, textAlign: 'center' }}>Caricamento...</p>}
      {!loading && spese.length === 0 && (
        <p style={{ color: theme.colors.textMuted, textAlign: 'center', marginTop: 20 }}>
          Nessun pagamento effettuato ancora.
        </p>
      )}

      {spese.map(pagamento => {
        const totale = pagamento.amount_total / 100;
        const worker = pagamento.amount_worker / 100;
        const commissione = pagamento.amount_commission / 100;
        const statusInfo = statusLabels[pagamento.status] || { emoji: '⏳', label: pagamento.status, bg: 'backgroundAlt', color: 'textMuted' };
        const jobTitle = pagamento.applications?.jobs?.title || 'Lavoro';
        const jobCategory = pagamento.applications?.jobs?.category;

        return (
          <div key={pagamento.id} style={{ border: `1px solid ${theme.colors.border}`, borderRadius: theme.radius.lg, padding: theme.spacing.lg, marginBottom: theme.spacing.md }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
              <span style={{ fontWeight: 600, fontSize: theme.font.size.lg }}>{jobTitle}</span>
              <span style={{ color: theme.colors.textPrimary, fontWeight: 700 }}>€{totale.toFixed(2)}</span>
            </div>

            <div style={{ fontSize: theme.font.size.sm, color: '#888', marginBottom: 6 }}>
              €{worker.toFixed(2)} al lavoratore + €{commissione.toFixed(2)} commissione Jobbetty
            </div>

            <div style={{ fontSize: theme.font.size.sm, color: theme.colors.textMuted, marginBottom: 10 }}>
              {new Date(pagamento.created_at).toLocaleDateString('it-IT')}
              {jobCategory && ` · ${jobCategory}`}
            </div>

            <span style={{
              background: theme.colors[statusInfo.bg], color: theme.colors[statusInfo.color],
              padding: '3px 10px', borderRadius: theme.radius.md, fontSize: theme.font.size.sm
            }}>
              {statusInfo.emoji} {statusInfo.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default Spese;